var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.923,
    height: 25,
    viewBox: "0 0 26.923 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "photo_booth",
    transform: "translate(-105 -52.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9473",
    "data-name": "Path 9473",
    d: "M129.038,52.5H107.885A2.884,2.884,0,0,0,105,55.385V70.769a2.884,2.884,0,0,0,2.885,2.885h1.923v2.885a.957.957,0,0,0,1.394.856l7.49-3.74h10.346a2.884,2.884,0,0,0,2.885-2.885V55.385a2.884,2.884,0,0,0-2.885-2.885Zm-21.154,1.923h21.154a.961.961,0,0,1,.962.962v8.259l-4.808-4.808a2.885,2.885,0,0,0-3.846-.211l-7.75,6.192a.961.961,0,0,1-.6.211h-6.077V55.385a.961.961,0,0,1,.962-.962Zm21.154,17.308H118.462a.96.96,0,0,0-.433.106l-6.3,3.144V72.692a.961.961,0,0,0-.962-.962h-2.885a.961.961,0,0,1-.962-.962V66.923h6.058a2.884,2.884,0,0,0,1.8-.635l7.75-6.192h0a.962.962,0,0,1,1.279.067L130,66.356v4.413a.961.961,0,0,1-.962.962Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9474",
    "data-name": "Path 9474",
    d: "M160.865,111.731a3.366,3.366,0,1,0-2.38-.986A3.365,3.365,0,0,0,160.865,111.731Zm0-4.808a1.442,1.442,0,1,1-1.02.422A1.442,1.442,0,0,1,160.865,106.923Z",
    transform: "translate(-49.615 -49.615)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9475",
    "data-name": "Path 9475",
    d: "M425.769,332.5h-4.808a.962.962,0,1,0,0,1.923h4.808a.962.962,0,1,0,0-1.923Z",
    transform: "translate(-297.693 -264.615)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu3);
export default __webpack_public_path__ + "static/media/menu-3.0867be3372b1c13cee92900a795af0e4.svg";
export { ForwardRef as ReactComponent };